export const BASE_URL = 'https://sqftbackend-i52w4.ondigitalocean.app/api/v1';
// export const BASE_URL = 'http://localhost:8080/api/v1';